import { Collapse, Flex } from "antd";
import styled from "styled-components";

export const StyledDashboardCollapse = styled(Collapse)`
    border: none;
    width: 100%;

    .ant-collapse-content-box {
        padding: 0px !important;
        background-color: ${(props) =>
            props.theme.collapseHeaderBackground} !important;
        border-radius: 0 0 8px 8px !important;
    }

    .ant-collapse-item {
        background-color: transparent !important;
    }
    .ant-collapse-header {
        padding: 14px !important;
        border-radius: 8px !important;
        background-color: ${(props) =>
            props.theme.collapseHeaderBackground} !important;
    }

    .ant-collapse-item-active {
        .ant-collapse-header {
            border-radius: 8px 8px 0 0 !important;
        }
    }
`;

export const StyledDashboardCollapseList = styled(Flex)`
    padding: 16px;
    flex-direction: column;
    gap: 12px;
    width: 100%;

    :last-child {
        padding: 0;
        border: none;
    }
`;

export const StyledDashboardCollapseListItem = styled(Flex)`
    width: 100%;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px 12px;
    padding-bottom: 12px;
    border-bottom: 1px solid ${(props) => props.theme.secondaryBorderColor};
`;
